import {useNavigate} from "react-router-dom";
import {useTranslation} from "react-i18next";
import BrandLogo from "../../../utils/brands/BrandLogo.jsx";
import {useBrand} from "../../../utils/brands/branding.js";
import ActionButton from "../../../components/ActionButton.jsx";
import {formatIntegrationDateTime, getIntegrationLastUpdate, getIntegrationSourceNames, getIntegrationState, isShoptetAddonIntegration} from "./integrationListPresentation.js";

const stateClasses = {
    active: 'border-emerald-200 bg-emerald-100 text-emerald-700 dark:border-emerald-800 dark:bg-emerald-950/40 dark:text-emerald-300',
    paused: 'border-amber-200 bg-amber-100 text-amber-800 dark:border-amber-800 dark:bg-amber-950/40 dark:text-amber-300',
    inactive: 'border-rose-200 bg-rose-100 text-rose-700 dark:border-rose-800 dark:bg-rose-950/40 dark:text-rose-300',
};

export default function ThirdPartyServiceRow({projectIntegration}) {
    const navigate = useNavigate();
    const {t} = useTranslation();
    const brand = useBrand(projectIntegration.name);
    const state = getIntegrationState(projectIntegration);
    const sources = getIntegrationSourceNames(projectIntegration);
    const updatedAt = formatIntegrationDateTime(getIntegrationLastUpdate(projectIntegration));
    const detailUrl = `/project/${projectIntegration.project}/settings/integrations?integrationId=${projectIntegration.id}`;
    const stateLabel = {
        active: t('project.integration-state-active', {defaultValue: 'Aktivní'}),
        paused: t('project.integration-state-paused', {defaultValue: 'Pozastaveno'}),
        inactive: t('project.integration-state-inactive', {defaultValue: 'Neaktivní'}),
    }[state];

    return <article className={'group mb-3 rounded-xl border border-slate-200 bg-white px-4 py-4 shadow-sm transition hover:border-violet-500 dark:border-slate-700 dark:bg-slate-800 dark:hover:border-violet-500'}>
        <div className={'flex items-start gap-4'}>
            <button type={'button'} className={'flex min-w-0 flex-1 items-start gap-4 text-left'} onClick={() => navigate(detailUrl)}>
                <BrandLogo brand={brand}/>
                <span className={'min-w-0 flex-1'}>
                    <span className={'flex flex-wrap items-center gap-2'}>
                        <span className={'text-base font-semibold text-slate-900 dark:text-white'}>{brand.name}</span>
                        <span className={`inline-flex rounded-full border px-2.5 py-1 text-xs font-medium ${stateClasses[state]}`}>{stateLabel}</span>
                    </span>
                    <span className={'mt-2 block text-sm leading-5 text-slate-600 dark:text-slate-300'}>
                        <span className={'font-semibold text-slate-700 dark:text-slate-200'}>{isShoptetAddonIntegration(projectIntegration) ? t('project.shoptet-addon-source', {defaultValue: 'E-shop'}) : t('project.integration-active-sources', {defaultValue: 'Aktivní zdroje'})}:</span>{' '}
                        {sources.length > 0 ? sources.join(', ') : isShoptetAddonIntegration(projectIntegration) ? t('project.shoptet-addon-source-unavailable', {defaultValue: 'Adresa e-shopu není dostupná'}) : t('project.integration-no-source-selected', {defaultValue: 'Zatím není vybrán žádný zdroj'})}
                    </span>
                    <span className={'mt-1 block text-xs text-slate-500 dark:text-slate-400'}>
                        {updatedAt
                            ? t('project.integration-last-update', {defaultValue: 'Aktualizováno: {{date}}', date: updatedAt})
                            : t('project.no-regular-update-yet')}
                    </span>
                </span>
            </button>
            {brand?.editable !== false && <ActionButton icon={'pencil'} onClick={() => navigate(detailUrl)}/>}
        </div>
    </article>;
}
